import { useTranslation } from 'react-i18next';

import { Info } from './Info';

export const CreditLimitExceededError = () => {
  const { t } = useTranslation(['checkoutMessages']);

  return <Info header={t('checkoutMessages:credit_limit_exceeded.header')} />;
};
